export const ALL_ROLES = [
  'administrator', 'omborchi', 'qabul_operator', 'buxgalter', 'bolim_xodimi',
  'rahbar', 'prorector', 'komissiya', 'tuzilma_operatori',
];

export const ROLE_LABELS = {
  administrator: 'Administrator',
  omborchi: 'Omborchi',
  qabul_operator: 'Xarid operatori',
  buxgalter: 'Buxgalter',
  bolim_xodimi: 'Bo‘lim mas’uli',
  rahbar: 'Rahbar',
  prorector: 'Iqtisodiy va tashkiliy masalalar bo‘yicha prorektor',
  komissiya: 'Inventarizatsiya komissiyasi',
  tuzilma_operatori: 'Tuzilma operatori',
};

export const PAGE_ROLES = {
  dashboard: ['administrator','omborchi','qabul_operator','buxgalter','bolim_xodimi','rahbar','prorector','komissiya'],
  items: ['administrator','omborchi','rahbar','prorector'],
  balance: ['administrator','omborchi','rahbar','prorector'],
  stockIn: ['administrator','omborchi','buxgalter','rahbar','prorector'],
  stockOut: ['administrator','omborchi','rahbar','prorector'],
  requests: ['administrator','omborchi','qabul_operator','buxgalter','bolim_xodimi','rahbar','prorector'],
  itemRequests: ['administrator','omborchi','qabul_operator','buxgalter','bolim_xodimi','rahbar','prorector'],
  reports: ['administrator','omborchi','rahbar','prorector'],
  monitoring: ['administrator','omborchi','rahbar','prorector'],
  assets: ['administrator','omborchi','buxgalter','rahbar','prorector'],
  assetWriteoffs: ALL_ROLES,
  retiredAssets: ['administrator','omborchi','buxgalter','rahbar','prorector','komissiya'],
  users: ['administrator','rahbar','tuzilma_operatori'],
  departments: ['administrator','tuzilma_operatori'],
  settings: ['administrator'],
  profile: ALL_ROLES,
  assetScan: ['administrator','omborchi','qabul_operator','buxgalter','bolim_xodimi','rahbar','prorector','komissiya'],
};

export const canAccess = (role, page) => Boolean(role && PAGE_ROLES[page]?.includes(role));
